export default __webpack_public_path__ + "static/media/timelineUserAdded.8f9fb99c.svg";